<template>
  <div class="wrap" id="analytics_btn">
    <button class="chevron" v-if="type != 'all'" @click="$emit('prevMonth')">
      <img src="@/assets/images/icons/chevron-left.svg">
    </button>
    <div class="wrap_button">
      <button class="btn" @click="isVisibleMenu = !isVisibleMenu">
        <img src="../../assets/images/icons/calendar-black.svg" alt="">
        <span>{{ type == 'all' ? 'За все время' : display[type]}}</span>
      </button>
      <transition name="fade">
        <div class="wrap_button_content" v-if="isVisibleMenu">
          <div>
            <button @click="$emit('changeType', 'month'); isVisibleMenu = !isVisibleMenu">{{ display.month }}</button>
          </div>
          <div>
            <button @click="$emit('changeType', 'year'); isVisibleMenu = !isVisibleMenu">{{ display.year }} год</button>
          </div>
          <div>
            <button @click="$emit('changeType', 'all'); isVisibleMenu = !isVisibleMenu">За все время</button>
          </div>
        </div>
      </transition>
    </div>
    <button class="chevron" v-if="type != 'all'" @click="$emit('nextMonth')">
      <img src="@/assets/images/icons/chevron-right.svg">
    </button>
  </div>
</template>

<script>
export default {
  name: "AnalitycsBtn",
  data: () => ({
    isVisibleMenu: false
  }),
  props: {
    display:{
      type: [Array, Object],
      default: () => ({month: '0', year: '0'})
    },
    type:{
      type: String,
      default: 'month'
    }
  },
  methods: {
    clickListener(e) {
      const foundedItem = e.path.find(el => el.id === 'analytics_btn')
      if (!foundedItem) this.isVisibleMenu = false
    }
  },
  watch: {
    isVisibleMenu(v) {
      if (v) {
        const listener = () => document.addEventListener('click', this.clickListener)
        setTimeout(listener, 0)
      } else {
        document.removeEventListener('click', this.clickListener)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  margin-left: 20px;
  display: flex;
  align-items: center;

  .chevron {
    border: none;
    background-color: transparent;
  }

  &_button {
    margin: 0 10px;
    position: relative;

    .btn {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding-left: 10px;
      width: 150px;
      height: 32px;
      background-color: #FFFFFF;
      border: 1px solid #DBBFA7;
      border-radius: 5px;

      span {
        font-size: 16px;
        line-height: 24px;
        color: #383838;
        margin-left: 5px;
        margin-bottom: -2px;
      }
    }

    &_content {
      width: 150px;
      top: calc(100% + 5px);
      z-index: 9999;
      background-color: #fff;
      border: 1px solid #DBBFA7;
      border-radius: 5px;
      padding: 15px 20px;
      padding-bottom: 5px;
      position: absolute;

      button {
        font-size: 16px;
        line-height: 24px;
        color: #383838;
        background-color: transparent;
        border: none;
        margin-bottom: 15px;
        position: relative;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .wrap {
    margin-top: 5px;
    margin-left: 0;
    width: 100%;
    &_button {
      width: 100%;
    }
    .btn {
      width: 100%;
    }
  }
}
</style>
